import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TokensService } from '../../../shared/services/tokens.service';

import { ButtonComponent } from '../../../shared/components/button/button.component';
import { SvgIconComponent } from '../../../shared/components/svg-icon/svg-icon.component';

import { IButtonConfig } from '../../../shared/interfaces/button.interfaces';
import { ISvgConfig } from '../../../shared/interfaces/svg.interfaces';

import { EButtonTypes, EButtonSizes } from '../../../shared/enums/button.enums';
import { ESvgTypes } from '../../../shared/enums/svg.enums';
import { ECallButton } from '../../../enums/voice-call.enums';

@Component({
  selector: 'stxt-primer-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, SvgIconComponent],
  templateUrl: './primer-modal.component.html',
  styleUrl: './primer-modal.component.scss'
})
export class PrimerModalComponent implements OnInit {
  @Input() tokensBalance: number;
  @Output() closePrimerModal: EventEmitter<ECallButton> = new EventEmitter<ECallButton>();
  public primaryButton: IButtonConfig = {
    text: ECallButton.CALL_NOW,
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Small
  };
  public secondaryButton: IButtonConfig = {
    text: ECallButton.CALL_LATER,
    fill: EButtonTypes.SecondaryDark,
    buttonSize: EButtonSizes.Small
  };
  public callIcon: ISvgConfig = { name: 'call-simple', fill: ESvgTypes.None };
  public tokenIcon: ISvgConfig = { name: 'token-star', fill: ESvgTypes.None };
  public clockIcon: ISvgConfig = { name: 'clock-emoji', fill: ESvgTypes.None };
  public callPrice: number = 4;
  public availableMinutes: number;
  public footerText: string = ECallButton.CALL_LATER;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly tokensService: TokensService
  ) {}

  ngOnInit(): void {
    this.initItems();
    this.availableMinutes = this.calcAvailableMinutes();
  }

  initItems(): void {
    if (this.tokensBalance < this.callPrice) {
      this.primaryButton.text = ECallButton.GET_CALL_MINUTES;
      this.secondaryButton.text = ECallButton.CALL_LATER;
      this.footerText = `Minimum ${this.callPrice} tokens to start`;
    } else {
      this.primaryButton.text = ECallButton.CALL_NOW;
      this.secondaryButton.text = ECallButton.GET_MORE_MINUTES;
      this.footerText = ECallButton.CALL_LATER;
    }
  }

  calcAvailableMinutes(): number {
    if (this.tokensBalance < this.callPrice) {
      return 0;
    } else {
      return Math.floor(this.tokensBalance / this.callPrice);
    }
  }

  buttonClick(action: string): void {
    if (action === ECallButton.GET_CALL_MINUTES || action === ECallButton.GET_MORE_MINUTES) {
      this.tokensService.getMoreTokensEvent$.next(true);
      return;
    }
    this.activeModal.close(action);
  }
}
